export {};

declare global {
  interface Array<T> {
    groupBy(o: T): Array<T>;
  }
}

Object.defineProperty(Array.prototype, 'groupBy', {
  value: function (prop) {
    return this.reduce((groups, item) => {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  },
  enumerable: false
});
